// action types
import { createRequestTypes } from "../../utils";

export const FETCH_TRENDING_DATA = createRequestTypes("FETCH_TRENDING_DATA");

export const fetchTrendingDataRequest = () =>
    ({ type: FETCH_TRENDING_DATA.REQUEST });

export const fetchTrendingDataSuccess = (data) =>
    ({ type: FETCH_TRENDING_DATA.SUCCESS, payload: { data } });

export const fetchTrendingDataFailure = (error) =>
    ({ type: FETCH_TRENDING_DATA.FAILURE, payload: { error } });
